import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { QuoteCalculations } from "../../types/Calculation";

export const getQuoteCalculations = (quoteId: string) => {
  const { fetchWithAuth } = useApi();

  return useQuery({
    queryKey: ["quote-calculations", quoteId],
    queryFn: (): Promise<QuoteCalculations> => {
      return fetchWithAuth<QuoteCalculations>("getQuoteCalculations", quoteId);
    },
  });
};
